import React from 'react';
import cover from "../assets/large-grid.png";
import icon from "../assets/contact-arrow.png";

const Contact = () => {
  return (
    <div className='contact' id='contact'>
      <img className='grid-contact' src={cover} />

      <div className='sec1-about'>
        <p className='head-about'>You are now entering my 'Contact Me' section</p>
        <p className='tag-about'>4</p>
      </div>

      <div className='connect-sec'>
        <p>Let's make it happen together!</p>

        <div className='email-contact'>
          <input type='email' placeholder='Your E-Mail'/>
          <button>Connect!</button>
        </div>
      </div>

      <div className='contact-icons'>
          <a href='https://www.instagram.com/_pineapple_on_my_pizza_/' target='_blank'>
            <div>
              <p>Instagram</p>
              <img src={icon} />
            </div>
          </a>

          <a href='https://www.linkedin.com/in/vikramaditya-datta-178b2b216/' target='_blank'>
            <div>
              <p>LinkedIn</p>
              <img src={icon} />
            </div>
          </a>

          <a href='https://www.behance.net/vikramadityadatta' target='_blank'>
            <div>
              <p>Behance</p>
              <img src={icon} />
            </div>
          </a>

          <a href='https://dribbble.com/pineapplelmao' target='_blank'>
            <div>
              <p>Dribble</p>
              <img src={icon} />
            </div>
          </a>
        </div>

        <a href='/' className='vikram-name'>VIKRAMADITYA DATTA</a>
    </div>
  )
}

export default Contact;
